import script from "./NotificationUndoOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationUndoOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationUndoOverlay.vue?vue&type=style&index=0&id=3aa17f72&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aa17f72"]])

export default __exports__